import { AuxiliaryDataFieldType } from '@vendasta/account-group';
import { FieldType } from '@vendasta/crm';

export interface CustomFieldOperation {
  name: string;
  value: string;
  supportedFieldTypes?: AuxiliaryDataFieldType[];
}

const numericFieldTypes = [
  AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_INTEGER,
  AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_CURRENCY,
];
// The `value` of these CustomFieldOperations is used in the cloud function to decide what to do with the data
// An empty value for supportedFieldTypes means that it's supported for all field types.
export const CustomFieldOperations: CustomFieldOperation[] = [
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.SET_VALUE',
    value: 'SET_VALUE',
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.CLEAR_VALUE',
    value: 'CLEAR_VALUE',
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.APPEND',
    value: 'APPEND',
    supportedFieldTypes: [AuxiliaryDataFieldType.AUXILIARY_DATA_FIELD_TYPE_STRING],
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.ADD',
    value: 'ADD',
    supportedFieldTypes: numericFieldTypes,
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.SUBTRACT',
    value: 'SUBTRACT',
    supportedFieldTypes: numericFieldTypes,
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.MULTIPLY',
    value: 'MULTIPLY',
    supportedFieldTypes: numericFieldTypes,
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.DIVIDE',
    value: 'DIVIDE',
    supportedFieldTypes: numericFieldTypes,
  },
];

export interface CRMFieldOperation {
  name: string;
  value: string;
  supportedFieldTypes?: FieldType[];
}

const crmNumericFieldTypes = [FieldType.FIELD_TYPE_INTEGER, FieldType.FIELD_TYPE_CURRENCY];
export const CRMFieldOperations: CRMFieldOperation[] = [
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.SET_VALUE',
    value: 'SET_VALUE',
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.CLEAR_VALUE',
    value: 'CLEAR_VALUE',
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.APPEND',
    value: 'APPEND',
    supportedFieldTypes: [FieldType.FIELD_TYPE_STRING, FieldType.FIELD_TYPE_TAG],
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.ADD',
    value: 'ADD',
    supportedFieldTypes: crmNumericFieldTypes,
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.SUBTRACT',
    value: 'SUBTRACT',
    supportedFieldTypes: crmNumericFieldTypes,
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.MULTIPLY',
    value: 'MULTIPLY',
    supportedFieldTypes: crmNumericFieldTypes,
  },
  {
    name: 'AUTOMATIONS.EDITOR.TASKS.MODIFY_CUSTOM_FIELD_DATA.OPERATIONS.DIVIDE',
    value: 'DIVIDE',
    supportedFieldTypes: crmNumericFieldTypes,
  },
];
